/**
 * New navigation.js.
 *
 */

function makeAllTabbable(elements) {
    if(!elements) return;
    Array.from(elements).map(elem => {
        elem.setAttribute('tabindex', '0');
    });
}

function makeAllUntabbable(elements) {
    if(!elements) return;

    Array.from(elements).map(elem => {

        // Always want the top level buttons tabbable
        if(!elem.classList.contains('main-inner')) {
            elem.setAttribute('tabindex', '-1');
        }
    });
}

function openMenu(menu) {
    if(!menu) return;
    makeAllTabbable(menu.querySelectorAll('a'));
    makeAllTabbable(menu.querySelectorAll('button'));
    menu.classList.add('active');
}

function closeMenus(menus) {
    if(!menus) return;

    Array.from(menus).forEach(function(menu) {
        // Closing a menu makes all focusble elements not tabbable
        makeAllUntabbable(menu.querySelectorAll('a'));
        makeAllUntabbable(menu.querySelectorAll('button'));
        menu.classList.remove('active');
    });
}

const newNav = document.querySelector('.new-header__nav');
if (newNav) {

    //main menu toggle
    const mainMenuItems = newNav.querySelectorAll('li.main-menu-item.menu-item-has-children button.main-inner');
    Array.from(mainMenuItems).map(elem => {
        elem.addEventListener("click", (event) => {
            event.preventDefault();
            const parentMenu = elem.parentElement;
            if(parentMenu.classList.contains('active')) {
                parentMenu.classList.remove('active');
            } else {

                const menusWithChildren = newNav.querySelectorAll('li.main-menu-item.menu-item-has-children');
                closeMenus(menusWithChildren);

                openMenu(parentMenu);
            }
        })
    })
    const mainMenuClose = newNav.querySelectorAll('li.main-menu-item.menu-item-has-children button.close-button');
    Array.from(mainMenuClose).map(elem => {
        elem.addEventListener("click", (event) => {
            const directParentEl = elem.closest('li.main-menu-item.menu-item-has-children');
            if (directParentEl.classList.contains('active')) {

                directParentEl.classList.remove('active');

            } else {

                const menusWithChildren = newNav.querySelectorAll('li.main-menu-item.menu-item-has-children');
                closeMenus(menusWithChildren);

                openMenu(directParentEl);
            }
        });
    })

    //Sub menu toggle
    const itemList = newNav.querySelectorAll('.sub-menu-item.menu-item-has-children .sec-lvl-arrow');
    Array.from(itemList).map(elem => {
        elem.addEventListener("click", (event) => {
            const parentMenu = elem.parentElement;
            if(parentMenu.classList.contains('active')) {
                parentMenu.classList.remove('active');
            } else {

                const subMenusWithChildren = newNav.querySelectorAll('.sub-menu-item.menu-item-has-children');
                closeMenus(subMenusWithChildren);

                // Get top level menu and make everything tabbable again
                // Because the code above makes every sub menu with children not tabbable
                const topLevelMenu = parentMenu.closest('li.main-menu-item.menu-item-has-children');
                makeAllTabbable(topLevelMenu.querySelectorAll('a'));
                makeAllTabbable(topLevelMenu.querySelectorAll('button'));

                openMenu(parentMenu)
            }
        });
    })

    const titleList = newNav.querySelectorAll('.sub-menu-item.menu-item-has-children .sec-lvl-sub-menu__title');
    Array.from(titleList).map(elem => {

        const parentEl = elem.closest('.sub-menu-item.menu-item-has-children');

        elem.addEventListener("click", (event) => {
            if(parentEl.classList.contains('active')) {
                parentEl.classList.remove('active');
            } else {

                const subMenusWithChildren = newNav.querySelectorAll('.sub-menu-item.menu-item-has-children');
                closeMenus(subMenusWithChildren);

                // Get top level menu and make everything tabbable again
                // Because the code above makes every sub menu with children not tabbable
                const topLevelMenu = parentEl.closest('li.main-menu-item.menu-item-has-children');
                makeAllTabbable(topLevelMenu.querySelectorAll('a'));
                makeAllTabbable(topLevelMenu.querySelectorAll('button'));

                openMenu(parentEl)
            }
        });
    })

    //Third menu toggle
    const secLvlItems = newNav.querySelectorAll('.sec-lvl-sub-menu__item.menu-item-has-children .third-lvl-arrow');
    jQuery('.third-lvl-sub-menu', newNav).slideUp();
    Array.from(secLvlItems).map(elem => {
        elem.addEventListener("focus", (event) => {
            elem.classList.toggle('open');
            elem.parentElement.querySelector('.menu-inner').classList.toggle('open');
            jQuery('.third-lvl-sub-menu', elem.parentElement).slideToggle('slow');
        });
    })
}
